export class BreadcrumbService {
    constructor() {
        'ngInject';

        this.breadcrumbs = [];
    }

    setPageBreadcrumbs(breadcrumbs) {
        this.breadcrumbs = this._setBreadcrumbsObject(breadcrumbs);
    }

    _setBreadcrumbsObject(breadcrumbs) {
        return breadcrumbs.map(({
            slug,
            name,
            display_name:displayName
        }) => ({
            slug,
            name,
            displayName
        }));
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/breadcrumb/breadcrumb.service.js